// extracted by mini-css-extract-plugin
export default {"modal-overlay":"error_modal_modal-overlay__EpJyR","modal":"error_modal_modal__-Kn0Z","title":"error_modal_title__dlKJv","body":"error_modal_body__Pwgs9"};